module.exports = __webpack_public_path__ + "img/List Icon - charcoal.1c6d017a.svg";